import '../login/login.scss';
import ChangePasswordForm from '../../components/change-password/change-password';

const ChangePassword = () => {
    
    return(
        <div className='login_container'>
            <ChangePasswordForm />
        </div>
    );
}

export default ChangePassword;